import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';

import { concatWithDot } from 'helpers/string';

import { prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES } from './utils/form';

export const ProductAndServicesDeliveryAndSupport: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_PRODUCTS_AND_SERVICES.DELIVERY_AND_SUPPORT,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('productsAndServicesForm.title')}
          badgeText={t('productsAndServicesForm.deliveryAndSupport.title')}
          section={FOR_BANK_SECTIONS.PRODUCTS_AND_SERVICES}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.deliveryAndSupport.deliveryAndLogisticsDetails')}
        aiFieldName={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS)}
      >
        {/* 3.4.1 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.deliveryAndSupport.logistic"
          name={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.LOGISTICS)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.deliveryAndSupport.postPurchaseSupport')}
        aiFieldName={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE)}
      >
        {/* 3.4.2 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.deliveryAndSupport.postPurchase"
          name={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.POST_PURCHASE)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('productsAndServicesForm.deliveryAndSupport.warrantyOrReturnProgram')}
        aiFieldName={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY)}
      >
        {/* 3.4.3 */}
        <TextInputControl
          multiline
          control={control}
          id="productsAndServicesForm.deliveryAndSupport.anyWarranty"
          name={concatWithDot(prefix, PRODUCTS_AND_SERVICES_DELIVERY_AND_SUPPORT_NAMES.ANY_WARRANTY)}
          minRows={4}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
